import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Users } from "lucide-react";

const ClanCardSkeleton = () =>{
    return (
        <Card className="flex flex-col h-full overflow-hidden border dark:bg-[#1F2937] dark:text-white animate-pulse">
            <CardHeader className="bg-gray-100 dark:bg-gray-800 p-4 flex flex-row items-center justify-between">
                <Skeleton className="flex items-center gap-3">
                    <Skeleton className="bg-gray-200 dark:bg-gray-700 text-white p-2 rounded-full">
                        <Skeleton className="h-5 w-5" />
                    </Skeleton>
                    <div className="flex flex-col gap-1">
                        <Skeleton className="h-4 w-36 bg-gray-200 dark:bg-gray-700 rounded" />
                        <Skeleton className="h-3 w-44 bg-gray-200 dark:bg-gray-700 rounded" />
                    </div>
                </Skeleton>
                <div className="text-right flex flex-col items-end gap-1">
                    <Skeleton className="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded" />
                    <Skeleton className="h-3 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
            </CardHeader>

            <CardContent className="bg-gray-100 dark:bg-gray-800 flex-1 p-0 flex flex-col justify-between">
                <div className="max-h-[300px] overflow-x-auto dark:bg-[#1F2937]">
                    <Table>
                        <TableHeader className="bg-gray-100 dark:bg-gray-800">
                            <TableRow>
                                <TableHead>
                                    <Skeleton className="h-4 w-24 bg-gray-200 dark:bg-gray-700" />
                                </TableHead>
                                <TableHead>
                                    <Skeleton className="h-4 w-16 ml-auto text-right bg-gray-200 dark:bg-gray-700" />
                                </TableHead>
                                <TableHead>
                                    <Skeleton className="h-4 w-12 ml-auto text-right bg-gray-200 dark:bg-gray-700" />
                                </TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody className="bg-gray-100 dark:bg-gray-800">
                            {[...Array(1)].map((_, i) => (
                                <TableRow key={i}>
                                    <TableCell>
                                        <Skeleton className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
                                    </TableCell>
                                    <TableCell className="text-right">
                                        <Skeleton className="h-4 w-16 ml-auto bg-gray-200 dark:bg-gray-700 rounded" />
                                    </TableCell>
                                    <TableCell className="text-right">
                                        <Skeleton className="h-4 w-12 ml-auto bg-gray-200 dark:bg-gray-700 rounded" />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>

                <div className="p-3 border-t bg-gray-100 dark:bg-gray-800 flex justify-between items-center">
                    <Skeleton className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
                    <Skeleton className="h-8 w-24 bg-gray-200 dark:bg-gray-700 rounded-md" />
                </div>
            </CardContent>
        </Card>
    );
}
export default ClanCardSkeleton;
